import {
  addMonths,
  addWeeks,
  endOfDay as endDay,
  format,
  getISOWeekYear,
  getISOWeeksInYear,
  isBefore,
  isFuture,
  isPast,
  isSameDay,
  isWeekend,
  nextMonday,
  parseISO,
  setISOWeek,
  startOfDay as startDay,
  startOfWeek,
  startOfYear,
  subWeeks,
} from 'date-fns'

const DATE_FORMAT = 'dd-LL-yyyy'
const DATETIME_FORMAT = 'dd-LL-yyyy HH:mm:ss'

const formatDate = (date?: any) => date && format(new Date(date), DATE_FORMAT)
const formatDateTime = (date?: any) =>
  date && format(new Date(date), DATETIME_FORMAT)
const startOfDay = (date?: any) => date && startDay(new Date(date))
const endOfDay = (date?: any) => date && endDay(new Date(date))
const pastDay = (date?: any) => date && isPast(new Date(date))
const futureDay = (date?: any) => date && isFuture(new Date(date))
const isToday = (date?: any) => date && isSameDay(new Date(date), new Date())
const skipWeekend = (date?: any) => {
  if (!date) return

  const d = new Date(date)

  return isWeekend(d) ? nextMonday(d) : d
}

const formatWeekYearToISOWeek = (year, week) =>
  year && week && format(setISOWeek(year.setMonth(2), week), "RRRR-'W'II") // eslint-disable-line
const formatDateToISOWeek = (date) =>
  date && format(new Date(date), "RRRR-'W'II")

const beginningOfYearDateForISOWeek = (dateString?: string) =>
  dateString
    ? new Date(getISOWeekYear(parseISO(dateString)).toString())
    : new Date()

const subtractWeeks = (date: any, weeks: any) =>
  date instanceof Date && !Number.isNaN(date) && subWeeks(date, weeks)

const isDate = (date: any): date is Date => {
  return date instanceof Date && !isNaN(date.getTime())
}

const MID_YEAR_MONTH = 6

// Number of ISO weeks (52 or 53) in an ISO week-numbering year. Uses a date in
// the middle of the year, so it can't fall in the previous or next ISO year
const weeksInISOYear = (year: number) =>
  getISOWeeksInYear(new Date(year, MID_YEAR_MONTH))

const isValidISOWeek = (week: any): boolean => {
  if (!week || typeof week !== 'string') return false

  return /^\d{4}-W\d{2}$/.test(week)
}

export {
  addWeeks,
  endOfDay,
  formatDate,
  formatDateTime,
  formatDateToISOWeek,
  formatWeekYearToISOWeek,
  futureDay,
  isBefore,
  isToday,
  isValidISOWeek,
  parseISO,
  pastDay,
  skipWeekend,
  startOfDay,
  subtractWeeks,
  beginningOfYearDateForISOWeek,
  isDate,
  addMonths,
  startOfWeek,
  startOfYear,
  weeksInISOYear,
}
